/* eslint-disable camelcase */
export default class User {
  constructor ({ name, role_name, email, user_id, created_at, surname, role_id }) {
    this.name = name || ''
    this.roleName = role_name || ''
    this.email = email || ''
    this.userId = user_id || ''
    this.createdAt = created_at || ''
    this.surname = surname || ''
    this.roleId = role_id || ''
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/models/User.js